import { LocalDateTime } from "@gen/travel/v1/common_pb";

export function localDateTimeToDate(d: LocalDateTime): Date {
  return new Date(
    d.year,
    d.month - 1, // JavaScript Date months are 0-based
    d.day,
    d.hours,
    d.minutes,
    d.seconds,
    Math.floor(d.nanos / 1_000_000), // nanos to millis
  );
}
